import { Trans } from "@lingui/macro";
import { UiTypography } from "@smp/ui";
import { testAppendAttr } from "@smp/utils";

import { useDialog } from "@/hooks/use_dialog";
import { useEpBillingAccount } from "@/hooks/use_ep_billing_account";

import { HeaderButton } from "../../shared";
import { DialogClassic } from "./dialog_classic";

export const Classic = () => {
  const {
    close: dialogClose,
    isOpen: isDialogOpen,
    open: dialogOpen,
  } = useDialog();
  const { accountList } = useEpBillingAccount();

  if (!accountList) return null;

  const postsAmount = accountList.reduce((accumulator, account) => {
    if (account.commodity === "POST") {
      accumulator += account.balance;
    }
    return accumulator;
  }, 0);

  return (
    <>
      <HeaderButton
        {...testAppendAttr("id", `header_billing_classic`)}
        onClick={dialogOpen}
        textLeft={<Trans>Posts</Trans>}
        textRight={<UiTypography>{postsAmount}</UiTypography>}
      />
      {isDialogOpen && <DialogClassic onClose={dialogClose} />}
    </>
  );
};
